import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { fetch_all_roles } from '../../api/roleAPI'
import DataTable from '../../components/ui/DataTable'
import AdminLayout from '../../layouts/AdminLayout'
import { tidy_date, tidy_time_difference } from '../../utils/helper'
import { MdAdd, MdCheck } from 'react-icons/md'

export default function RolePermissionPage() {
  const navigate = useNavigate()
  const [pageData, setPageData] = useState([])

  const fetchRolePermissionData = async () => {
    let { data, error, message } = await fetch_all_roles()
    if (error) return console.error(message)
    data = data.sort((a, b) => a.permissions.length - b.permissions.length)
    setPageData(data)
  }

  useEffect(() => {
    fetchRolePermissionData()
  }, [])

  const table_columns = [
    { header: 'Role', accessor: 'name' },
    { header: 'Super Admin', accessor: 'is_super_admin', modifier: (data) => data == 1 ? <MdCheck /> : null },
    { header: 'Default User', accessor: 'is_default_user', modifier: (data) => data == 1 ? <MdCheck /> : null },
    { header: 'Permissions', accessor: 'permissions', modifier: (data) => `${data.length} permissions` },
    { header: "Last Updated", accessor: "updatedAt", modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})` }
  ]

  return (
    <AdminLayout
      navSelected={"Roles & Permissions"}
      headerText={"Role Permissions"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Roles & Permissions</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/roles-permissions/details?role_id=new")
            }}
          >
            <MdAdd size={16} />
            New Role
          </button>
        </>
      }
    >
      <DataTable
        data={pageData}
        columns={table_columns}
        placeholder="No roles available"
        enableActions={true}
        onRowSelect={(row) => navigate(`/admin/roles-permissions/details?role_id=${row.id}`)}
        enableSelection={false}
        accessorKey="id"
        tableName={"RolePermissionsTable"}
        actions={(row) => {
          return (
            <div className="flex gap-2">
              <button className="hover:underline" onClick={() => navigate(`/admin/roles-permissions/details?role_id=${row.id}`)}>
                Edit
              </button>
            </div>
          )
        }}
      />
      {/* <pre>{JSON.stringify(pageData, null, 2)}</pre> */}
    </AdminLayout>
  )
}
